import React from "react";
import {
    Col,

    Drawer,
    Form,
    Input,
    InputNumber,
    Row,
    Typography,
} from "antd";
import { Button } from "src/components/actions/button";
import { CloseSvg, RotateClockwiseSvg, SaveSvg } from "src/components/Svg";
import { useAppData } from "src/store/app-data";
import {
    getInitialValues,
    whiteSpaceValidation
} from "src/utils/helpers";
import styled from "styled-components";
import {MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";

const { Title } = Typography

export function TableEditDrawer({
                               title,
                               onClose,
                               onSave,
                               initialData,
                               pointId
                           }) {

    const layoutConfig = useAppData((state) => state.layoutConfig);

    const [form] = Form.useForm();


    React.useEffect(() => {
        const elements = form.getFieldValue("elements") || [];
        if (elements.length === 0) {
            form.setFieldsValue({
                elements: [
                    {
                        name: undefined,
                        number: undefined,
                    },
                ],
            });
        }
    }, []);

    React.useEffect(() => {
        if (initialData && initialData.elements.length > 0) {
            form.setFieldsValue(getInitialValues(initialData))
        } else {
            form.setFieldsValue({
                elements: [
                    {
                        name: undefined,
                        number: undefined,
                    },
                ],
            });
        }
    }, [initialData]);

    function prepareData(values) {
        return {
            elements: values.elements.map((element) => ({
                ...element,
                pointId
            }))
        }
    }
    async function onSubmit(values) {
        const data = prepareData(values)

        try {
            await onSave(data);

            form.resetFields()
        } catch (e) {
            console.log("Ошибка: ", e)
        }
    }

    function handleClose() {
        onClose();
        form.resetFields();
    }

    return (
        <DrawerEdit
            width={layoutConfig.isMobile ? "90%" : "80%"}
            title={title}
            onClose={handleClose}
            open
        >
            <FormEdit form={form} layout={"vertical"} onFinish={(values) => onSubmit(values)}>
                <Form.List name="elements">
                    {(fields, { add, remove }) => (
                        <>
                            {fields.map(({ key, name, ...field }, index) => (
                                <React.Fragment key={`RowTitle_${index}`}>
                                    <RowTitle level={4}>
                                        Стол {key + 1}{" "}
                                        {fields.length > 1 ? (
                                            <MinusCircleOutlined
                                                className="dynamic-delete-button"
                                                style={{ marginLeft: "12px" }}
                                                onClick={() => remove(name)}
                                            />
                                        ) : null}
                                    </RowTitle>
                                    <Form.Item required={false} key={key}>
                                        <StyledFormItem
                                            key={pointId + "_" + index + "_name"}
                                            label={"Название"}
                                            name={[name, "name"]}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Ввведите название!",
                                                },
                                                {
                                                    validator: whiteSpaceValidation
                                                }
                                            ]}
                                        >
                                            <Input maxLength={256} />
                                        </StyledFormItem>
                                        <StyledFormItem
                                            key={pointId + "_" + index + "_number"}
                                            label={"Номер столика"}
                                            name={[name, "number"]}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Ввведите номер столика!",
                                                },
                                            ]}
                                        >
                                            <InputNumber min={1} style={{ width: "100%"}}/>
                                        </StyledFormItem>
                                    </Form.Item>
                                    <Form.Item
                                        noStyle
                                        shouldUpdate={(prev, curr) =>
                                            prev.elements?.[index]?.number !== curr.elements?.[index]?.number
                                        }
                                    >
                                        {({ getFieldValue }) => {
                                            const tableNumber = getFieldValue(["elements", index, "number"]);
                                            return (
                                                tableNumber && Number(tableNumber) > 0 && (
                                                    <div style={{ margin: "-10px 0 20px 0" }}>
                                                        <h4>Ссылка для QR-кода:</h4>
                                                        <h3>{`https://bushe.ru/screens/orders/table/${pointId}/${tableNumber}`}</h3>
                                                    </div>
                                                )
                                            );
                                        }}
                                    </Form.Item>
                                </React.Fragment>
                            ))}
                            <Row gutter={28}>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item>
                                        <Button
                                            type="dashed"
                                            onClick={() => add()}
                                            style={{ width: "100%" }}
                                            icon={<PlusOutlined />}
                                        >
                                            Добавить
                                        </Button>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </>
                    )}
                </Form.List>
                <ButtonRow>
                    <ButtonCol>
                        <Button
                            danger
                            onClick={() => {
                                form.resetFields();
                            }}
                            icon={<RotateClockwiseSvg />}
                        >
                            Вернуть
                        </Button>
                    </ButtonCol>
                    <ButtonCol>
                        <Button onClick={handleClose} icon={<CloseSvg />}>
                            Закрыть
                        </Button>
                    </ButtonCol>
                    <ButtonCol>
                        <Button icon={<SaveSvg />} type="primary" htmlType="submit">
                            Отправить
                        </Button>
                    </ButtonCol>
                </ButtonRow>
            </FormEdit>
        </DrawerEdit>
    );
}

const DrawerEdit = styled(Drawer)``;

const FormEdit = styled(Form)``;

const StyledFormItem = styled(Form.Item)`
  margin-bottom: 16px;
`;

const ButtonCol = styled(Col)`
  padding-bottom: 5px;
`;

const ButtonRow = styled(Row)`
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;

  .ant-col {
    margin-left: 0.4em;
  }
`;

const RowFlex = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
`
const RowTitle = styled(Title)`
  margin-bottom: 20px;
`


